import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";
import { toast } from "react-toastify";
const FieldActivityTaskForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [machineClose, setMachineClose] = useState(false);
  const [labourClose, setlabourClose] = useState(false);

  const [employeeId, setEmployeeId] = useState(null);
  const [employeelist, setEmployeelist] = useState(null);

  const [fieldActivityId, setFieldActivityId] = useState(null);
  const [farmActivityList, setFarmActivityList] = useState(null);
  const [activityAreaUnitId, setActivityAreaUnitId] = useState(0);
  const [activityArea, setActivityArea] = useState(0);

  const [assignEmployeeId, setAssignEmployeeId] = useState();

  const [plotId, setPlotId] = useState();
  const [plotData, setPlotData] = useState([]);

  const [cropPlotId, setCropPlotId] = useState();
  const [cropPlotData, setCropPlotData] = useState([]);

  const [getpassproductdata, setgetpassproductdata] = useState([]);
  const [procurmentProductdata, setprocurmentProductdata] = useState([]);
  const [totalProcuredQuantity, settotalProcuredQuantity] = useState();
  const [totalProcuredQuantityUnit, settotalProcuredQuantityUnit] = useState();
  const [totalProcuredQuantityUnitId, settotalProcuredQuantityUnitId] =
    useState();
  const [currencyCode, setCurrencyCode] = useState(
    localStorage.getItem("currencyCode")
  );

  const [productTypeId, setProductTypeId] = useState();
  const [productTypeList, setProductTypeList] = useState([]);

  const [productSubTypeId, setProductSubTypeId] = useState();
  const [productSubTypeList, setProductSubTypeList] = useState([]);

  const [productId, setProductId] = useState();
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const [productSubTypeFilterList, setProductSubTypeFilterList] = useState([]);
  const [productFilterList, setProductFilterList] = useState([]);

  const [machineTypeList, setMachineTypeList] = useState([
    { typename: "Own" },
    { typename: "Rented" },
  ]);
  const [machineType, setMachineType] = useState();

  const [machineList, setMachineList] = useState([]);
  const [machineFilterList, setMachineFilterList] = useState([]);
  const [activityMachineries, setActivityMachineries] = useState([]);

  const [vehicleId, setVehicleId] = useState();
  const [selectedMachine, setSelectedMachine] = useState();

  const [classificationList, setClassificationList] = useState([
    { classificationName: "Equipment" },
    { classificationName: "Machine" },
    { classificationName: "Vehicle" },
  ]);
  const [classification, setClassification] = useState();

  const [productUnitId, setProductUnitId] = useState();
  const [unitList, setUnitList] = useState([]);
  const [unitFilterList, setUnitFilterList] = useState([]);
  const [ratePerHr, setRatePerHr] = useState();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  var d = new Date();

  const { sendRequest: getGatePass } = useHttp();
  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=CommercialFarming&orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getfieldActivity } = useHttp();

  useEffect(() => {
    getfieldActivity(
      {
        url: `/api/farmActivity/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("farmActivity", data);
        setFarmActivityList(data);
      }
    );
  }, [getfieldActivity]);

  const { sendRequest: getplotDetails } = useHttp();

  const FillplotDetails = (id) => {
    //console.log("getplotDetails");

    var url = ``;

    var urlfilter = "";

    url = `/api/plotDetails/?orgId=${localStorage.getItem(
      "orgId"
    )}&fieldExecutiveId=${id}`;

    getplotDetails(
      {
        url: url,
      },
      (res) => {
        //console.log("getplotDetails", res);
        setPlotData(res);
        if (props.update)
        {
          FillCrppPlotDetails(props.update.plotId,res);
        }
        
      }
    );
  };

  const { sendRequest: getCrppPlotDetails } = useHttp();

  const FillCrppPlotDetails = (id,pData) => {
    var plotArea = "0";
    var plotAreaUnit = "";
    var plotAreaUnitId = "0";
    if (id !== 0) {
      var plotObj = pData.filter((item) => item.plotId == id);
      plotArea = plotObj && plotObj[0].plotArea;
      plotAreaUnit = plotObj && plotObj[0].unitAbbreviation;
      plotAreaUnitId = plotObj && plotObj[0].plotAreaUnitId;
    }
    setActivityArea(plotArea);
    setActivityAreaUnitId(plotAreaUnitId);
    frmRef.current.plotarea.value = plotArea;
    frmRef.current.plotAreaUnit.value = plotAreaUnit;
    var url = ``;

    var urlfilter = "";

    url = `/api/cropDetails/?orgId=${localStorage.getItem(
      "orgId"
    )}&plotId=${id}`;

    getCrppPlotDetails(
      {
        url: url,
      },
      (res) => {
        console.log("FillCrppPlotDetails", res);
        setCropPlotData(res);
        if (props.update)
        {
        setCropPlotId(props.update.cropPlotId)
        }
      
      
      }
    );
  };

  const { sendRequest: getItemType } = useHttp();

  useEffect(() => {
    getItemType(
      {
        url: `/api/fillProductTypesWithoutServices/`,
      },
      (res) => {
        if (res) {
          setProductTypeList(res);
        }
      }
    );
  }, [getItemType]);

  const { sendRequest: getProductSubType } = useHttp();
  useEffect(() => {
    getProductSubType(
      {
        url: `/api/productsubitem/`,
      },
      (res) => {
        if (res) {
          setProductSubTypeList(res);
        }
      }
    );
  }, [getProductSubType]);

  const productTypeOnchangedHandler = (Id) => {
    var dataList = productSubTypeList.filter(
      (item) => item.productTypeId == Id
    );

    setProductSubTypeFilterList(dataList);
  };

  const { sendRequest: getProduct } = useHttp();

  useEffect(() => {
    getProduct(
      {
        url: `/api/product/`,
      },
      (res) => {
        if (res) {
          setProductList(res);
        }
      }
    );
  }, [getProduct]);

  const { sendRequest: getUnit } = useHttp();

  useEffect(() => {
    getUnit(
      {
         url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setUnitList(res);
        }
      }
    );
  }, [getUnit]);

  const productSubTypeOnchangedHandler = (Id) => {
    var dataList = productList.filter((item) => item.productSubTypeId == Id);

    setProductFilterList(dataList);
  };

  const productchangedHandler = (Id) => {
    var dataList = productList.filter((item) => item.productId == Id);
    //console.log("Product dataList", dataList && dataList[0].unitId);
    var unitTypelist = unitList.filter(
      (item) => item.unitId == (dataList && dataList[0].unitId)
    );
    //console.log("Product unitTypelist", unitTypelist);
    var unitDatalist = unitList.filter(
      (item) => item.unitTypeId == (unitTypelist && unitTypelist[0].unitTypeId)
    );
    setProductUnitId(dataList && dataList[0].unitId);
    setUnitFilterList(unitDatalist);
    setSelectedProduct(dataList && dataList[0]);
  };

  const { sendRequest: getpassIdProc } = useHttp();

  const { sendRequest: postProcurementReciept } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    // if (getpassproductdata.length == 0) {
    //   toast("Please enter at least one product!");
    //   setClose(true);
    //   return;
    // }

    // //console.log("zero", procurmentProductdata[procurmentProductdata.length-1].itemQuantity=="" ? "0" :  procurmentProductdata[procurmentProductdata.length-1].itemQuantity  )
    //  var  zeroQtyProduct=procurmentProductdata.filter((item)=> parseFloat(item.itemQuantity==""?"0":item.itemQuantity)==0)

    // if (zeroQtyProduct.length > 0) {
    //   toast("Please enter quantity of the product!");
    //   setClose(true);
    //   return;
    // }
    const now = new Date();
    const fieldActivityDetailIdGen = Math.round(now.getTime() / 1000);

    const MobCreatedDate = new Date().toISOString().slice(0, 10);

    if (props.update) {
      fieldActivityDetailIdGen = props.update.fieldActivityDetailId;
    }
    // productDetails.map((x) => (x["fieldActivityDetailId"] = fieldActivityDetailIdGen));

    const data = {
      fieldActivityDetailId: fieldActivityDetailIdGen,
      startDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      startTime: frmRef.current.activityStartTime.value,
      fieldActivityId: fieldActivityId,
      cropPlotId: cropPlotId,
      activityArea: frmRef.current.plotarea.value,
      estimatedTimeToCompleteActivity:
        frmRef.current.estimatedTimeToCompleteActivity.value,
      activityProducts: productDetails,
      activityMachineries: activityMachineries,
      instructionAny: frmRef.current.InstructionAny.value,
      activityAreaUnitId: activityAreaUnitId,
      status: 1,
      activityStatus: 1,
      mobCreatedDate: moment(MobCreatedDate).format("DD/MM/YYYY hh:mm:ss"),
      createdBy: parseInt(localStorage.getItem("id")),
      entryLatLong: { lat: "18.6227329", long: "73.7748456" },
      orgId: localStorage.getItem("orgId"),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
    };
    //console.log("data", data);

    postProcurementReciept(
      {
        url: "/api/fieldActivityWeb/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(
          `Field Activity task detail ${props.update ? "updated" : "added"} `
        );
        props.addForm(false);
      }
    );
  };

  const submitProduct = (e) => {
    e.preventDefault();

    var selectedUnit = unitList.filter((item) => item.unitId == productUnitId);
    console.log("selectedProduct",selectedProduct);
    const productName = selectedProduct && selectedProduct.productName;
    const productTypeName = selectedProduct && selectedProduct.productTypeName;
    const productSubTypeName =
      selectedProduct && selectedProduct.productSubTypeName;
    const productQuantity = productRef.current.productQuantity.value;
    // const rate = productRef.current.itemUnitPrice.value;
    const productCost = productRef.current.productCost.value;
    const productUnit = selectedUnit && selectedUnit[0].unitAbbreviation;
    const now = new Date();
    const FieldActivityProductIdGen = Math.round(now.getTime() / 1000);
    const MobCreatedDate = new Date().toISOString().slice(0, 10);

    if (
      !productName ||
      !productTypeName ||
      !productSubTypeName ||
      !productQuantity ||
      !productQuantity ||
      !productUnit ||
      !productCost
    ) {
      toast.success("Please fill in all fields!");

      return;
    } else {
      const productName = selectedProduct && selectedProduct.productName;
      const isDuplicate = productDetails.some(
        (product) => product.productName === productName
      );
      if (isDuplicate) {
        // alert('Item already exists!');
        toast.success("Product already exists!");

        return;
      }
      console.log("productTypeName",productTypeName)
      setProductDetails((x) => [
        ...x,
        {
          linesrNo: productDetails.length + 1,
          fieldActivityProductId: FieldActivityProductIdGen,
          productId: selectedProduct && selectedProduct.productId,
          productName: selectedProduct && selectedProduct.productName,
          productTypeName: productTypeName,
          productItemTypeId: productTypeId,
          productSubTypeName: productSubTypeName,
          productSubTypeId: productSubTypeId,
          quantity: productQuantity,
          oldQuantity: 0,
          costIncurred: productCost,
          unitId: productUnitId,
          productUnit: productUnit,
          mobCreatedDate: moment(MobCreatedDate).format("DD/MM/YYYY hh:mm:ss"),
          createdBy: parseInt(localStorage.getItem("id")),
          warehouseId: parseInt(localStorage.getItem("warehouseId")),
          orgId: localStorage.getItem("orgId"),
          status: 1,
        },
      ]);

      setProductId("");
      setProductSubTypeId("");
      setProductTypeId("");
      setProductUnitId("");
      setProductSubTypeFilterList([]);
      setProductFilterList([]);
      setUnitFilterList([]);

      productRef.current.productQuantity.value = 0;
      productRef.current.productCost.value = 0;
    }
    // //console.log(productDetails);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };


  useEffect(() => {
      console.log(props.update);
      if (props.update) {
        // // customerId: props.update
        // frmRef.current.customer_name.value = props.update.name;
        // setAttachmentUrl(props.update.fileAttachment);
        setAssignEmployeeId(props.update.fieldExecutiveId)
        setPlotId(props.update.plotId)
        FillplotDetails(props.update.fieldExecutiveId)
        setFieldActivityId(props.update.fieldActivityId)
        frmRef.current.estimatedTimeToCompleteActivity.value= props.update.duration
        frmRef.current.InstructionAny.value= props.update.instructionAny
        
  
        // // fileAttachment: attachmentUrl,
        // // paymentTermsInDays: frmRef.current.payment_days.value,
      }
    }, [props.update]);
  
  

  useEffect(() => {
    frmRef.current.activityStartTime.value =
      d.getHours() + ":" + d.getMinutes();
    //console.log("activityStartTime", frmRef.current.activityStartTime.value);
  }, [employeelist]);

  const submitMachine = (e) => {
    e.preventDefault();

    //console.log("selectedMachine", selectedMachine);
    const _classification = selectedMachine && selectedMachine.vmeClassific;
    const _machineType = selectedMachine && selectedMachine.vmeOwnershipType;
    const modelName = selectedMachine && selectedMachine.vmeModelName;
    const workHours = productRef.current.workHours.value;
    const costIncurred = productRef.current.machineCostIncurred.value;

    const now = new Date();
    const FieldActivityMachineryIdgen = Math.round(now.getTime() / 1000);
    const MobCreatedDate = new Date().toISOString().slice(0, 10);
    //console.log(_classification, _machineType);
    if (
      !_classification ||
      !_machineType ||
      !modelName ||
      !workHours ||
      !costIncurred
    ) {
      toast.success("Please fill in all fields!");

      return;
    } else {
      const isDuplicate = activityMachineries.some(
        (product) => product.modelName === modelName
      );
      if (isDuplicate) {
        // alert('Item already exists!');
        toast.success("Machine already exists!");

        return;
      }

      setActivityMachineries((x) => [
        ...x,
        {
          linesrNo: activityMachineries.length + 1,
          fieldActivityMachineryId: FieldActivityMachineryIdgen,
          machineType: _machineType,
          classification: _classification,
          modelName: modelName,
          vehicleId: vehicleId,
          workHours: workHours,
          costIncurred: costIncurred,
          mobCreatedDate: moment(MobCreatedDate).format("DD/MM/YYYY hh:mm:ss"),
          createdBy: parseInt(localStorage.getItem("id")),
          orgId: localStorage.getItem("orgId"),
          status: 1,
        },
      ]);

      setClassification("");
      setMachineType("");
      setVehicleId("");
      setRatePerHr("0");
      setMachineFilterList([]);

      productRef.current.workHours.value = 0;
      productRef.current.machineCostIncurred.value = 0;
    }
    // //console.log(productDetails);
  };

  const { sendRequest: getMachineDetail } = useHttp();
  useEffect(() => {
    const vvmrUrl = `/api/vehicleMachineEquipRegistratn/?orgId=${localStorage.getItem(
      "orgId"
    )}`;

    getMachineDetail(
      {
        url: vvmrUrl,
      },
      (res) => {
        if (res) {
          setMachineList(res);
        }
      }
    );
  }, [getMachineDetail]);

  const fillModelName = (_machineType, _classification) => {
    var dataList = machineList.filter(
      (item) =>
        item.vmeOwnershipType == _machineType &&
        item.vmeClassific == _classification
    );

    setMachineFilterList(dataList);
  };

  const machineModelchangedHandler = (Id) => {
    var dataList = machineList.filter((item) => item.vmerId == Id);

    setRatePerHr((dataList && dataList[0].ratePerHr) || 0);
    setSelectedMachine(dataList && dataList[0]);
  };

  return (
    <>
      {close && (
        <Modal isOpen={close} style={customModalStyles}>
          <div>
            <div>
              <h4 className="card-title">Product Details</h4>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor={"PlotId"}>{"Product Type"}</label>

                    <select
                      id="cropNameId"
                      className="form-control"
                      ref={(el) =>
                        (productRef.current["productItemTypeId"] = el)
                      }
                      value={productTypeId}
                      onChange={(e) => {
                        var id = 0;

                        if (e.target.value != "--Select Product Type--") {
                          id = e.target.value;
                        }
                        setProductTypeId(id);
                        productTypeOnchangedHandler(id);
                      }}
                    >
                      <option>--Select Product Type--</option>
                      {productTypeList &&
                        productTypeList.map((x) => (
                          <option
                            key={x.productItemTypeId}
                            crop-id={x.productItemTypeId}
                            value={x.productItemTypeId}
                          >
                            {x.productTypeName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <label htmlFor={"PlotId"}>{"Product Subtype"}</label>
                  <select
                    id="cropNameId"
                    className="form-control"
                    ref={(el) => (productRef.current["productSubTypeId"] = el)}
                    value={productSubTypeId}
                    onChange={(e) => {
                      var id = 0;

                      if (e.target.value != "--Select Product Subtype--") {
                        id = e.target.value;
                      }
                      setProductSubTypeId(id);
                      productSubTypeOnchangedHandler(id);
                    }}
                  >
                    <option>--Select Product Subtype--</option>
                    {productSubTypeFilterList &&
                      productSubTypeFilterList.map((x) => (
                        <option
                          key={x.productSubTypeId}
                          crop-id={x.productSubTypeId}
                          value={x.productSubTypeId}
                        >
                          {x.productSubTypeName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label htmlFor={"PlotId"}>{"Product Name"}</label>
                  <select
                    id="cropNameId"
                    className="form-control"
                    ref={(el) => (productRef.current["productId"] = el)}
                    value={productId}
                    onChange={(e) => {
                      var id = 0;

                      if (e.target.value != "--Select Product--") {
                        id = e.target.value;
                      }
                      setProductId(id);
                      productchangedHandler(id);
                    }}
                  >
                    <option>--Select Product--</option>
                    {productFilterList &&
                      productFilterList.map((x) => (
                        <option
                          key={x.productId}
                          crop-id={x.productId}
                          value={x.productId}
                        >
                          {x.productName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor={"productQuantity"}>{"Quantity"}</label>
                  <input
                    type={"text"}
                    id={"productQuantity"}
                    required
                    ref={(el) => (productRef.current["productQuantity"] = el)}
                    className="form-control"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor={"PlotId"}>{"Unit"}</label>
                  <select
                    id="cropNameId"
                    className="form-control"
                    ref={(el) => (productRef.current["cropId"] = el)}
                    value={productUnitId}
                    onChange={(e) => {
                      var id = 0;

                      if (e.target.value != "--Select Unit--") {
                        id = e.target.value;
                      }
                      setProductUnitId(id);
                    }}
                  >
                    <option>--Select Unit--</option>
                    {unitFilterList &&
                      unitFilterList.map((x) => (
                        <option
                          key={x.unitId}
                          crop-id={x.unitId}
                          value={x.unitId}
                        >
                          {x.unitAbbreviation}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor={"productCost"}>{"productCost"}</label>
                  <input
                    type={"text"}
                    id={"productCost"}
                    required
                    ref={(el) => (productRef.current["productCost"] = el)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="row">&nbsp;</div>
            <div className="row">
              <div className="col-md-4"> </div>
              <div className="col-md-4">
                <button
                  className="btn  btn-success mx-2 my-2"
                  onClick={submitProduct}
                >
                  +
                </button>
              </div>
              <div className="col-md-4"></div>
            </div>
            <div className="row">&nbsp;</div>

            <table className="table table-bordered text-center">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Product Type</th>
                  <th>Product subType</th>
                  <th>Product Name</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Cost</th>
                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.linesrNo}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.quantity}</td>
                        <td>{itm.productUnit}</td>
                        <td>{itm.costIncurred}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <button
                className="btn  btn-primary mx-2 my-2"
                onClick={() => {
                  //console.log("productDetails", productDetails);

                  productDetails &&
                    productDetails.map((x) => (x["isSave"] = true));

                  //console.log(productDetails);
                  setClose(false);
                }}
              >
                Save
              </button>
            </div>
            <div className="col-md-4"></div>
          </div>
        </Modal>
      )}

      {machineClose && (
        <Modal isOpen={setMachineClose} style={customModalStyles}>
          <div>
            <div>
              <h4 className="card-title">Machinery and Equipment Details</h4>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setMachineClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>

              <div className="row">
                <div className="col-md-4">
                  <label htmlFor={"PlotId"}>{"Machine Type"}</label>

                  <select
                    id="cropNameId"
                    className="form-control"
                    ref={(el) => (productRef.current["machineType"] = el)}
                    value={machineType}
                    onChange={(e) => {
                      var id = "";

                      if (e.target.value != "--Select Machine Type--") {
                        id = e.target.value;
                      }
                      setMachineType(id);
                      fillModelName(id, classification);
                    }}
                  >
                    <option value="">--Select Machine Type--</option>
                    {machineTypeList &&
                      machineTypeList.map((x) => (
                        <option
                          key={x.typename}
                          crop-id={x.typename}
                          value={x.typename}
                        >
                          {x.typename}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label htmlFor={"PlotId"}>{"Classification"}</label>
                  <select
                    id="cropNameId"
                    className="form-control"
                    ref={(el) => (productRef.current["productSubTypeId"] = el)}
                    value={classification}
                    onChange={(e) => {
                      var id = 0;

                      if (e.target.value != "--Select Classification--") {
                        id = e.target.value;
                      }
                      setClassification(id);
                      fillModelName(machineType, id);
                    }}
                  >
                    <option>--Select Classification--</option>
                    {classificationList &&
                      classificationList.map((x) => (
                        <option
                          key={x.classificationName}
                          crop-id={x.classificationName}
                          value={x.classificationName}
                        >
                          {x.classificationName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label htmlFor={"PlotId"}>{"Model Name"}</label>
                  <select
                    id="cropNameId"
                    className="form-control"
                    ref={(el) => (productRef.current["productId"] = el)}
                    value={productId}
                    onChange={(e) => {
                      var id = 0;

                      if (e.target.value != "--Select Product--") {
                        id = e.target.value;
                      }
                      setVehicleId(id);
                      machineModelchangedHandler(id);
                    }}
                  >
                    <option value="">--Select Model Name--</option>
                    {machineFilterList &&
                      machineFilterList.map((x) => (
                        <option
                          key={x.vmerId}
                          crop-id={x.vmerId}
                          value={x.vmerId}
                        >
                          {x.vmeModelName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label htmlFor={"workHours"}>{"Work Hours"}</label>
                  <input
                    type={"text"}
                    id={"workHours"}
                    required
                    onChange={(e) => {
                      var hrs = e.target.value ?? "0";
                      var costIncurred =
                        parseFloat(hrs || 0) * parseFloat(ratePerHr);

                      productRef.current.machineCostIncurred.value =
                        costIncurred;
                    }}
                    ref={(el) => (productRef.current["workHours"] = el)}
                    className="form-control"
                  />
                </div>

                <div className="col-md-4">
                  <label htmlFor={"machineCostIncurred"}>
                    {"Cost Incurred"}
                  </label>
                  <input
                    type={"text"}
                    id={"machineCostIncurred"}
                    required
                    ref={(el) =>
                      (productRef.current["machineCostIncurred"] = el)
                    }
                    className="form-control"
                  />
                </div>
                <div className="col-md-4">
                  <br />
                  <button
                    className="btn  btn-primary mx-2 my-2"
                    onClick={submitMachine}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>

            <div className="row">&nbsp;</div>

            <table className="table table-bordered text-center">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Machine Type</th>
                  <th>Classification </th>
                  <th>Model Name</th>
                  <th>Work Hours</th>

                  <th>Cost Incurred</th>
                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {activityMachineries &&
                  activityMachineries.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.linesrNo}</td>
                        <td>{itm.machineType}</td>
                        <td>{itm.classification}</td>
                        <td>{itm.modelName}</td>
                        <td>{itm.workHours}</td>

                        <td>{itm.costIncurred}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="row">
            <div className="col-md-4"> </div>
            <div className="col-md-4">
              <button
                className="btn  btn-primary mx-2 my-2"
                onClick={() => {
                  activityMachineries.map((x) => (x["isSave"] = true));

                  setMachineClose(false);
                }}
              >
                Save
              </button>{" "}
            </div>
            <div className="col-md-4"> </div>
          </div>
        </Modal>
      )}

      {labourClose && (
        <Modal onClose={setlabourClose}>
          <div className="modal-heading-bar" style={{ width: "800px" }}>
            Labour Details
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Field Activity Task Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label> Date</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label>Field Activity Start Time</label>
                      <input
                        type={"time"}
                        id={"activityStartTime"}
                        required
                        ref={(el) => (frmRef.current["activityStartTime"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label> Assigned Supervisor</label>
                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          var id = 0;

                          if (e.target.value != "") {
                            id = e.target.value;
                          }
                          setAssignEmployeeId(id);
                          FillplotDetails(id);
                        }}
                      >
                        <option selected value="">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.userId}
                              user-id={x.userId}
                              value={x.userId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label>Plot</label>
                      <select
                        id="PlotId"
                        required
                        className="form-control"
                        value={plotId}
                        ref={(el) => (frmRef.current["PlotId"] = el)}
                        onChange={(e) => {
                          var id = 0;

                          if (e.target.value != "") {
                            id = e.target.value;
                          }
                          setPlotId(id);
                          FillCrppPlotDetails(id,plotData);
                        }}
                      >
                        <option selected value="">
                          --Select Plot--
                        </option>
                        {plotData &&
                          plotData.map((x) => (
                            <option key={x.plotId} value={x.plotId}>
                              {x.plotName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label>{"Crop"}</label>
                      <select
                        id="getpassId"
                        required
                        className="form-control"
                        value={cropPlotId}
                        ref={(el) => (frmRef.current["getpassId"] = el)}
                        onChange={(e) => {
                          var id = 0;

                          if (e.target.value != "") {
                            id = e.target.value;
                          }
                          setCropPlotId(id);
                        }}
                      >
                        <option selected value="">
                          --Select Crop--
                        </option>
                        {cropPlotData &&
                          cropPlotData.map((x) => (
                            <option key={x.cropPlotId} value={x.cropPlotId}>
                              {x.cropName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-2">
                      <label> {"Area"}</label>
                      <input
                        type={"text"}
                        id={"Area"}
                        readOnly="True"
                        ref={(el) => (frmRef.current["plotarea"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-2">
                      <label> {"Unit"}</label>
                      <input
                        type={"text"}
                        id={"plotAreaUnit"}
                        readOnly="True"
                        ref={(el) => (frmRef.current["plotAreaUnit"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label> {"Activity To Perform"}</label>
                      <select
                        id="getpassId"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["getpassId"] = el)}
                        onChange={(e) => {
                          var id = 0;

                          if (e.target.value != "") {
                            id = e.target.value;
                          }
                          setFieldActivityId(id);
                        }}
                      >
                        <option selected value="">
                          --Select farm Activity--
                        </option>
                        {farmActivityList &&
                          farmActivityList.map((x) => (
                            <option
                              key={x.fieldActivityId}
                              value={x.fieldActivityId}
                            >
                              {x.fieldActivityName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label>{"Estimated Time(Hrs)"}</label>
                      <input
                        type={"text"}
                        id={"procuredQuantity"}
                        value={totalProcuredQuantity}
                        required
                        ref={(el) =>
                          (frmRef.current["estimatedTimeToCompleteActivity"] =
                            el)
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label>{"Instruction"}</label>
                      <input
                        type={"text"}
                        id={"Instruction"}
                        value={totalProcuredQuantity}
                        required
                        ref={(el) => (frmRef.current["InstructionAny"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label> {"Product Details"}</label> <br />
                      <button
                        className="btn  btn-success btn-sm mx-2 my-2"
                        formNoValidate="True"
                        onClick={(e) => {
                          setClose(true);
                          e.preventDefault(false);
                          //console.log("Product", close);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-4">
                      <label> {"Machinery & Equipment"}</label> <br />
                      <button
                        className="btn btn-sm  btn-warning mx-2 my-2"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setMachineClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div className="text-center">
                    <div className="">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default FieldActivityTaskForm;
